import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { parseHtmlToReact, parseJson, prepareForParse } from '../../utils'

function CustomInformationList({
  data: { pageContext, ...pageData },
  // component props
  label = '',
  limit = undefined,
  groupBy = '',
  className = 'news_year',
}) {
  const { locale, publishYear = '' } = pageContext
  // Template 取得
  // 本来であれば variables で絞り込みたいが、制約がありできない
  // https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/#known-limitations
  const data = useStaticQuery(graphql`
    query {
      allContentfulTemplate(
        filter: { name: { regex: "/^customInformationList.*$/" } }
      ) {
        nodes {
          contentful_id
          __typename
          node_locale
          name
          body {
            raw
          }
          context {
            internal {
              content
            }
          }
        }
      }
    }
  `)
  const targetTemplateName = `customInformationList${
    groupBy ? `-${groupBy}` : ''
  }`
  const template = data.allContentfulTemplate.nodes.find(
    (node) => node.node_locale === locale && node.name === targetTemplateName
  )
  if (template === undefined) {
    throw new Error(
      `Template not found. templateName: ${targetTemplateName}, locale: ${locale}`
    )
  }

  const { categoryList = {}, titleSuffix = '' } =
    parseJson(template.context?.internal?.content) ?? {}

  // component props の label には複数ラベルを設定可能
  const filterLabels = label.split(',').filter((item) => item !== '')

  const informationList = pageData.allContentfulInformation.nodes
    .filter((node) => node.node_locale === locale)
    .filter(
      (node) => filterLabels.length === 0 || filterLabels.includes(node.label)
    )
    .filter((node) => publishYear === '' || node.publishYear === publishYear)
    .slice(0, limit)

  switch (groupBy) {
    case 'year':
      const yearList = informationList.reduce((acc, node) => {
        const year = node.publishYear
        if (!acc.includes(year)) {
          acc.push(year)
        }
        return acc
      }, [])

      return yearList.map((year, index) => (
        <div className={className} key={index}>
          <h3>
            {year}
            {titleSuffix}
          </h3>
          {informationList
            .filter((node) => node.publishYear === year)
            .map((node, index) => {
              const { htmlBody, componentData } = prepareForParse({
                template,
                data: {
                  ...pageData,
                  contentfulInformation: node,
                  context: {
                    categoryName: categoryList?.[node.label],
                  },
                },
                pageContext,
              })

              return (
                <React.Fragment key={index}>
                  {parseHtmlToReact(htmlBody, componentData)}
                </React.Fragment>
              )
            })}
        </div>
      ))
    // FIXME: もはや groupBy ではないが、修正量が多いのでそのままにしている
    case 'feature':
    default:
      if (informationList.length > 0) {
        return informationList.map((node, index) => {
          const { htmlBody, componentData } = prepareForParse({
            template,
            data: {
              ...pageData,
              contentfulInformation: node,
              context: {
                categoryName: categoryList?.[node.label],
              },
            },
            pageContext,
          })

          return (
            <React.Fragment key={index}>
              {parseHtmlToReact(htmlBody, componentData)}
            </React.Fragment>
          )
        })
      } else {
        return null
      }
  }
}

export { CustomInformationList }
